module.exports = __webpack_public_path__ + "img/jingbao0.gif";